import { Injectable, Inject } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";

import { ConfigurationActions } from "@actions/index";
import { CertificateActions } from "@actions/configuration";
import { OracleStorageService } from '@services/oracle-storage.service';
import { CertificateModel } from "@models/configuration/certificate.model";
import { isObject } from 'util';

@Injectable()
export class CertificateEffects {
  // Certificates Effects
  searchCertificates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.searchCertificates),
      switchMap(({ action }) =>
        this.oracleStorageService.search$(action).pipe(
          map((Certificates: CertificateModel[]) =>
            CertificateActions.searchCertificatesSuccess({ Certificates })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateActions.resetLoading())
          )
        )
      )
    )
  );

  searchCertificateStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.searchCertificateStatus),
      switchMap(({ action }) =>
        this.oracleStorageService.search$(action).pipe(
          map((CertificateStatus: CertificateModel[]) =>
            CertificateActions.searchCertificateStatusSuccess({ CertificateStatus })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateActions.resetLoading())
          )
        )
      )
    )
  );

  searchCertificatesState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.searchCertificatesState),
      switchMap(({ action }) =>
        this.oracleStorageService.search$(action).pipe(
          map((CertificatesByState: CertificateModel[]) =>
            CertificateActions.searchCertificatesStateSuccess({ CertificatesByState })
          ),
          catchError((error) => {
            let errorBack: string;
            if (isObject(error)) {
              if (error.message) {
                errorBack = error.message;
              } else {
                errorBack = "ERROR AL BUSCAR CERTIFICADOS POR ESTADO";
              }
            } else {
              errorBack = error;
            }
            return of(
              ConfigurationActions.configurationError({ error: errorBack })
            );
          })
        )
      )
    )
  );

  searchCertificatesFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.searchCertificatesFile),
      switchMap(({ action }) =>
        this.oracleStorageService.search$(action).pipe(
          /* tap(x=>console.log(x)),
          map((items:any[])=>{
            return items.map((element:any)=>{
              return {
                ...element,
                filestring: element.filePath
              }
            })
          }),
          tap(x=>console.log(x)), */
          map((CertificatesFile: CertificateModel[]) =>
            CertificateActions.searchCertificatesFileSuccess({ CertificatesFile })
          ),
          catchError((error) => {
            let errorBack: string;
            if (isObject(error)) {
              if (error.message) {
                errorBack = error.message;
              } else {
                errorBack = "ERROR AL BUSCAR CERTIFICADOS POR FILE";
              }
            } else {
              errorBack = error;
            }
            return of(
              ConfigurationActions.configurationError({ error: errorBack })
            );
          })
        )
      )
    )
  );

  createCertificates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.createCertificate),
      switchMap(({ action }) =>
        this.oracleStorageService.createSecond$(action).pipe(
          map((Certificate: CertificateModel) =>
            CertificateActions.createCertificateSuccess({ Certificate })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateActions.resetLoading())
          )
        )
      )
    )
  );

  updateCertificates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.updateCertificate),
      switchMap(({ action }) =>
        this.oracleStorageService.update$(action).pipe(
          map((Certificate: CertificateModel) =>
            CertificateActions.updateCertificateSuccess({ Certificate })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateActions.resetLoading())
          )
        )
      )
    )
  );

  deleteCertificates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.deleteCertificate),
      switchMap(({ action }) =>
        this.oracleStorageService.delete$(action).pipe(
          map((Certificate: CertificateModel) =>
            CertificateActions.deleteCertificateSuccess({ Certificate })
          ),
          catchError((error) =>
            of(ConfigurationActions.configurationError({ error }),CertificateActions.resetLoading())
          )
        )
      )
    )
  );
  /////////////
  constructor(
    private actions$: Actions,
    @Inject("OracleStorageService")
    private oracleStorageService: OracleStorageService<CertificateModel>
  ) {}
}
